export const SET_USER = 'user/SET_USER';
export const SET_PERMISSIONS = 'user/SET_PERMISSIONS';
export const USER_LOGOUT = 'user/USER_LOGOUT';
